import { PARTICIPANT_SELECT_UPDATE, PARTICIPANT_DESELECT } from "../action-types/controlPanelSelectedParticipant"

export const selectedParticipant = ({ participant }) => {
    return {
        type: PARTICIPANT_SELECT_UPDATE,
        payload: { selectedStatus: true, selectedParticipantId: participant.participantId, selectedParticipantDetail: participant },
    }
}

export const deselectedParticipant = () => {
    return { type: PARTICIPANT_DESELECT }
}
